@if (doShow()) {
  <div style="position: absolute; width: 40px; aspect-ratio: 1" [style]="position()" @scale>
    <div class="arrow" style="width: 100%; height: 100%" [style]="{ '--offset': offset() }">
      <app-style-sheet-sprite
        [sprite]="_stylesService.SPRITE_ICON_ARROW()?.container"
        [style]="arrowStyle()"
        style="display: block; width: 100%; height: 100%"
      />
    </div>
  </div>
}
